<template>
    <div>
        <v-card color="#fbf8f8" class="px-2">
            <v-card-title class="headline">Acciones rápidas:</v-card-title>
            <v-divider></v-divider>

            <v-card-text class="pa-0 px-1">
                <v-container grid-list-xl fluid class="px-1 py-3">
                    <v-layout row wrap>
                        <template v-for="(option, index) in options.actions">
                            <v-flex sm6 :key="`flex-${index}`" class="pa-1" @click="applyAction(option)">
                                <v-card :key="`card-${index}`" class="text-xs-center card-info">
                                    <v-card-text class="pa-0">
                                        <v-icon x-large>{{ option.icon }}</v-icon>
                                    </v-card-text>
                                    <v-card-text class="pt-0 px-1 pb-2">
                                        <v-btn small flat round outline dark color="blue" class="ma-0">{{
                                            option.text
                                        }}</v-btn>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </template>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: "CardInfoActions",
    props: {
        options: { type: Object, default: null }
    },
    data() {
        return {}
    },
    methods: {
        applyAction(option) {
            this.$emit("closeMenu")
            let route = { name: this.options.routeName, params: {} }
            route.params[`${option.attribute}`] = option.value
            this.$router.push(route)
        }
    },
    computed: {}
}
</script>

<style scoped>
.card-info {
    margin-left: 1px;
    margin-right: 1px;
    border-radius: 6px;
    transition: background-color 700ms;
}
.card-info:hover {
    background-color: #a4cedf;
    cursor: pointer;
}
</style>
